module.exports = __webpack_public_path__ + "static/media/Project-taiwan.61128cf3.svg";